import { render, staticRenderFns } from "./RChip.vue?vue&type=template&id=55d11218&scoped=true&"
import script from "./RChip.vue?vue&type=script&lang=js&"
export * from "./RChip.vue?vue&type=script&lang=js&"
import style0 from "./RChip.vue?vue&type=style&index=0&id=55d11218&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d11218",
  null
  
)

export default component.exports